import styled from "styled-components";

export const GridParameterizationContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 220px);
  overflow: hidden;
  position: relative;
`

export const Main = styled.div`
  color: var(--color-brand-300);
  flex: 1;
  overflow: auto;
  display: flex;
  min-height: 0;
  margin-bottom: 1rem;
  justify-content: space-between;
`

export const Footer = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
`
